// Lightweight Skeleton component - replaces NextUI Skeleton
import React from 'react';

const Skeleton = ({ 
  className = '',
  isLoaded = false,
  children,
  ...props 
}) => {
  if (isLoaded) {
    return <>{children}</>;
  }

  return (
    <div
      className={`bg-gray-200 animate-pulse rounded ${className}`}
      {...props}
    >
      {children || <div className="h-full w-full"></div>}
    </div>
  );
};

export default Skeleton;
